'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export function TestActivity() {
  const pathname = usePathname();
  useEffect(() => {
    const report = () => {
      void fetch('/api/test-environment/activity', { method: 'POST' });
    };
    report();
    const timer = window.setInterval(report, 5 * 60 * 1000);
    return () => window.clearInterval(timer);
  }, [pathname]);
  return null;
}
